const View = require('./view.js');
const Controller = require('./controller.js');

module.exports = function() {
  this.view = new View();
  this.controller = new Controller(this.view);
};


// WEBPACK FOOTER //
// ./app/remote/index.js